export default __webpack_public_path__ + "static/building-columns-light.png";